__turbopack_context__.v({
  "header": "vflNMa_header",
  "header__country-selector": "vflNMa_header__country-selector",
  "header__dropdown-skeleton": "vflNMa_header__dropdown-skeleton",
  "header__year-selector": "vflNMa_header__year-selector",
  "production-table": "vflNMa_production-table",
  "requirements-wrapper": "vflNMa_requirements-wrapper",
});
